@switch (type) { @case (productCardType.Commercial) {
<epc-commercial-product-card
  (cardClick)="cardClick.emit()"
  [deletable]="deletable"
  [product]="product"
  [productReference]="productReference"
  [showCommercialListDate]="showCommercialListDate"
  [prices]="product.priceRanges"
  [isDraggable]="isDraggable"
  [dragAndDropHandleTemplate]="dragAndDropHandleTemplate"
>
</epc-commercial-product-card>
} @default {
<epc-product-card
  (cardClick)="cardClick.emit()"
  [deletable]="deletable"
  [product]="product"
  [prices]="product.priceRanges"
  [showActions]="true"
  [isDraggable]="isDraggable && !showAsUnavailable"
  [dragAndDropHandleTemplate]="dragAndDropHandleTemplate"
  [showAsUnavailable]="showAsUnavailable"
  [showUnavailableDeleteButton]="showUnavailableDeleteButton"
  [isSearchV2Enabled]="isSearchV2Enabled"
>
</epc-product-card>
} }
